import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "toolbar", "count", "item", "actionSelect", "folderSelect"]

  connect() {
    this.selectedIds = new Set()
    this.updateToolbar()
  }

  toggleSelection(event) {
    const checkbox = event.target
    const mediaId = checkbox.dataset.mediaId

    if (checkbox.checked) {
      this.selectedIds.add(mediaId)
    } else {
      this.selectedIds.delete(mediaId)
    }

    this.updateItemVisual(checkbox)
    this.updateToolbar()
  }

  selectAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
      this.selectedIds.add(checkbox.dataset.mediaId)
      this.updateItemVisual(checkbox)
    })
    this.updateToolbar()
  }

  deselectAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
      this.updateItemVisual(checkbox)
    })
    this.selectedIds.clear()
    this.updateToolbar()
  }

  updateItemVisual(checkbox) {
    const item = checkbox.closest('[data-bulk-select-target="item"]')
    if (!item) return

    const thumbnail = item.querySelector('.aspect-square')
    if (!thumbnail) return

    if (checkbox.checked) {
      thumbnail.classList.remove('border-transparent')
      thumbnail.classList.add('border-blue-500')
      checkbox.classList.add('opacity-100')
      checkbox.classList.remove('opacity-0')
    } else {
      thumbnail.classList.remove('border-blue-500')
      thumbnail.classList.add('border-transparent')
      checkbox.classList.remove('opacity-100')
      checkbox.classList.add('opacity-0')
    }
  }

  updateToolbar() {
    const count = this.selectedIds.size

    if (count > 0) {
      this.toolbarTarget.classList.remove("hidden")
      this.countTarget.textContent = count
    } else {
      this.toolbarTarget.classList.add("hidden")
    }
  }

  applyBulkAction() {
    const action = this.actionSelectTarget.value

    if (!action) {
      alert("Please select a bulk action.")
      return
    }

    if (this.selectedIds.size === 0) {
      alert("Please select at least one item.")
      return
    }

    switch (action) {
      case "move":
        this.bulkMove()
        break
      case "trash":
        this.bulkDelete()
        break
      case "clone":
        this.bulkClone()
        break
    }
  }

  bulkMove() {
    document.getElementById("bulk-move-modal").showModal()
  }

  confirmMove() {
    const folder = this.folderSelectTarget.value

    const formData = new FormData()
    this.selectedIds.forEach(id => {
      formData.append("media_ids[]", id)
    })
    formData.append("folder", folder)

    document.getElementById("bulk-move-modal").close()
    this.submitBulkAction("/admin/media/bulk_update", formData, "Failed to move items.")
  }

  bulkDelete() {
    const message = `Are you sure you want to move ${this.selectedIds.size} item(s) to trash? This action cannot be undone.`
    if (!confirm(message)) return

    const formData = new FormData()
    this.selectedIds.forEach(id => {
      formData.append("media_ids[]", id)
    })

    this.submitBulkAction("/admin/media/bulk_destroy", formData, "Failed to delete items.")
  }

  bulkClone() {
    if (!confirm(`Clone ${this.selectedIds.size} item(s)?`)) return

    const formData = new FormData()
    this.selectedIds.forEach(id => {
      formData.append("media_ids[]", id)
    })

    this.submitBulkAction("/admin/media/bulk_clone", formData, "Failed to clone items.")
  }

  submitBulkAction(url, formData, errorMessage) {
    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": this.csrfToken
      },
      body: formData
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        alert(errorMessage + " Please try again.")
      }
    })
    .catch(error => {
      console.error("Error:", error)
      alert("An error occurred. Please try again.")
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
